import { useState, useEffect, useRef } from 'react';

// Keeps an expandable element mounted briefly after `open` flips to false so a collapse/exit
// animation can play before React unmounts it. Returns:
//   mounted — whether to render the element (true while open or animating out)
//   closing — true during the exit animation (add a class to play the out animation)
const useCollapse = (open, duration = 260) => {
  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    if (open) {
      setMounted(true);
      setClosing(false);
    } else {
      // Only animate out if it was actually showing; otherwise just stay unmounted.
      setClosing(true);
      timer.current = setTimeout(() => {
        setMounted(false);
        setClosing(false);
      }, duration);
    }
    return () => clearTimeout(timer.current);
  }, [open, duration]);

  return { mounted, closing };
};

export default useCollapse;
